'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { useState, useCallback, useMemo } from 'react';
import { getMediaDimensions } from '@edusense/entities-media';
/**
 * useTweetStore 훅은 이전 버전이지만 호환성을 위해 제공됨
 * 트윗 작성에 필요한 기본 기능들을 제공합니다.
 */ export var useTweetStore = function(selector) {
    // 상태 관리
    var _useState = _sliced_to_array(useState(''), 2), text = _useState[0], setText = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), media = _useState1[0], setMedia = _useState1[1];
    var _useState2 = _sliced_to_array(useState([
        '',
        ''
    ]), 2), pollOptions = _useState2[0], setPollOptions = _useState2[1];
    var _useState3 = _sliced_to_array(useState(24), 2), pollDuration = _useState3[0], setPollDuration = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), isPollActive = _useState4[0], setIsPollActive = _useState4[1];
    var _useState5 = _sliced_to_array(useState(null), 2), detectedUrl = _useState5[0], setDetectedUrl = _useState5[1];
    var _useState6 = _sliced_to_array(useState(null), 2), linkPreviewData = _useState6[0], setLinkPreviewData = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), projectPreviews = _useState7[0], setProjectPreviews = _useState7[1];
    var _useState8 = _sliced_to_array(useState(null), 2), fileInputRef = _useState8[0], setFileInputRef = _useState8[1];
    var _useState9 = _sliced_to_array(useState(null), 2), referenceTweet = _useState9[0], setReferenceTweet = _useState9[1];
    // 상태 초기화 함수 - useCallback으로 메모이제이션
    var resetState = useCallback(function() {
        setText('');
        setMedia([]);
        setPollOptions([
            '',
            ''
        ]);
        setPollDuration(24);
        setIsPollActive(false);
        setDetectedUrl(null);
        setLinkPreviewData(null);
        setProjectPreviews([]);
    }, []);
    // 투표 데이터 생성 함수 - useCallback으로 메모이제이션
    var createPollData = useCallback(function() {
        if (!isPollActive) return null;
        return {
            options: pollOptions.filter(function(option) {
                return option.trim().length > 0;
            }),
            durationHours: pollDuration
        };
    }, [
        isPollActive,
        pollOptions,
        pollDuration
    ]);
    // 제출 데이터 생성 함수 - useCallback으로 메모이제이션
    var createSubmitData = useCallback(function() {
        return {
            content: text,
            media: media,
            poll: createPollData()
        };
    }, [
        text,
        media,
        createPollData
    ]);
    // 허용되는 MIME 타입 목록
    var ALLOWED_MIME_TYPES = [
        'image/jpeg',
        'image/png',
        'image/gif',
        'image/webp',
        'video/mp4',
        'video/quicktime',
        'video/webm',
        'video/ogg',
        'video/x-matroska' // MKV 추가
    ];
    // 미디어 업로드 핸들러 - useCallback으로 메모이제이션
    var handleMediaUpload = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(e) {
            var newFiles, validFiles, enrichedMedia;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!e.target.files || e.target.files.length === 0) return [
                            2
                        ];
                        newFiles = Array.from(e.target.files);
                        validFiles = newFiles.filter(function(file) {
                            if (!ALLOWED_MIME_TYPES.includes(file.type)) {
                                console.warn("지원하지 않는 파일 형식입니다: ".concat(file.name, " (").concat(file.type, ")"));
                                return false;
                            }
                            return true;
                        });
                        return [
                            4,
                            Promise.all(validFiles.map(/*#__PURE__*/ function() {
                                var _ref = _async_to_generator(function(file, idx) {
                                    var width, height, dims, _, url, id, type;
                                    return _ts_generator(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                width = undefined;
                                                height = undefined;
                                                _state.label = 1;
                                            case 1:
                                                _state.trys.push([
                                                    1,
                                                    3,
                                                    ,
                                                    4
                                                ]);
                                                return [
                                                    4,
                                                    getMediaDimensions(file)
                                                ];
                                            case 2:
                                                dims = _state.sent();
                                                width = dims.width;
                                                height = dims.height;
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 3:
                                                _ = _state.sent();
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 4:
                                                url = URL.createObjectURL(file);
                                                id = "".concat(Date.now(), "-").concat(idx, "-").concat(file.name);
                                                type = file.type.startsWith('image/') ? 'image' : 'video';
                                                return [
                                                    2,
                                                    {
                                                        id: id,
                                                        url: url,
                                                        type: type,
                                                        width: width,
                                                        height: height,
                                                        file: file
                                                    }
                                                ];
                                        }
                                    });
                                });
                                return function(file, idx) {
                                    return _ref.apply(this, arguments);
                                };
                            }()))
                        ];
                    case 1:
                        enrichedMedia = _state.sent();
                        // 최대 4개 제한 적용
                        setMedia(function(prevMedia) {
                            var currentCount = prevMedia.length;
                            var availableSlots = Math.max(0, 4 - currentCount);
                            if (enrichedMedia.length > availableSlots) {
                                console.warn('미디어 파일은 최대 4개까지 첨부할 수 있습니다.');
                                return _to_consumable_array(prevMedia).concat(_to_consumable_array(enrichedMedia.slice(0, availableSlots)));
                            }
                            return _to_consumable_array(prevMedia).concat(_to_consumable_array(enrichedMedia));
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }(), [
        ALLOWED_MIME_TYPES
    ]);
    // 파일 선택 다이얼로그 열기 - useCallback으로 메모이제이션
    var openFileSelector = useCallback(function() {
        // 1) 우선 저장된 ref 사용
        if (fileInputRef === null || fileInputRef === void 0 ? void 0 : fileInputRef.current) {
            fileInputRef.current.click();
            return;
        }
        // 2) Fallback: DOM에서 컴포저 파일 입력 탐색 후 클릭
        var el = typeof document !== 'undefined' ? document.querySelector('input[type="file"][data-composer-file-input="true"]') : null;
        if (el) {
            el.click();
        } else {
            console.warn('[useTweetStore] file input element not found');
        }
    }, [
        fileInputRef
    ]);
    // 상태 객체를 useMemo로 메모이제이션
    var state = useMemo(function() {
        return {
            referenceTweet: referenceTweet,
            setText: setText,
            setMedia: setMedia,
            setPollOptions: setPollOptions,
            setPollDuration: setPollDuration,
            setIsPollActive: setIsPollActive,
            setDetectedUrl: setDetectedUrl,
            setLinkPreviewData: setLinkPreviewData,
            setProjectPreviews: setProjectPreviews,
            resetState: resetState,
            createPollData: createPollData,
            createSubmitData: createSubmitData,
            setFileInputRef: setFileInputRef,
            handleMediaUpload: handleMediaUpload,
            openFileSelector: openFileSelector,
            media: media,
            text: text
        };
    }, [
        referenceTweet,
        setText,
        setMedia,
        setPollOptions,
        setPollDuration,
        setIsPollActive,
        setDetectedUrl,
        setLinkPreviewData,
        setProjectPreviews,
        resetState,
        createPollData,
        createSubmitData,
        setFileInputRef,
        handleMediaUpload,
        openFileSelector,
        media,
        text
    ]);
    // 선택 함수 사용 시 선택한 상태 반환, 아니면 전체 상태 객체 반환
    if (selector && typeof selector === 'function') {
        return selector(state);
    }
    // 기본적으로 필요한 함수와 상태 반환
    return useMemo(function() {
        return {
            text: text,
            setText: setText,
            media: media,
            setMedia: setMedia,
            pollOptions: pollOptions,
            setPollOptions: setPollOptions,
            pollDuration: pollDuration,
            setPollDuration: setPollDuration,
            isPollActive: isPollActive,
            setIsPollActive: setIsPollActive,
            detectedUrl: detectedUrl,
            setDetectedUrl: setDetectedUrl,
            linkPreviewData: linkPreviewData,
            setLinkPreviewData: setLinkPreviewData,
            projectPreviews: projectPreviews,
            setProjectPreviews: setProjectPreviews,
            resetState: resetState,
            createPollData: createPollData,
            createSubmitData: createSubmitData,
            setFileInputRef: setFileInputRef,
            handleMediaUpload: handleMediaUpload,
            openFileSelector: openFileSelector,
            referenceTweet: referenceTweet,
            setReferenceTweet: setReferenceTweet
        };
    }, [
        text,
        setText,
        media,
        setMedia,
        pollOptions,
        setPollOptions,
        pollDuration,
        setPollDuration,
        isPollActive,
        setIsPollActive,
        detectedUrl,
        setDetectedUrl,
        linkPreviewData,
        setLinkPreviewData,
        projectPreviews,
        setProjectPreviews,
        resetState,
        createPollData,
        createSubmitData,
        setFileInputRef,
        handleMediaUpload,
        openFileSelector,
        referenceTweet,
        setReferenceTweet
    ]);
};
// Storybook에서 사용할 모의 상태 설정 함수
var mockReferenceTweet = null;
export var setupMockTweetStore = function(tweet) {
    mockReferenceTweet = tweet;
};
/**
 * 트윗 데이터 어댑터: OpenAPI 응답 형식에서 내부 타입으로 변환
 * @param tweetResponse API 응답으로 받은 트윗 데이터
 * @returns 내부 애플리케이션에서 사용하는 트윗 타입으로 변환된 데이터
 */ export var tweetDataAdapter = function(tweetResponse) {
    var _tweetResponse_author;
    // 기본 트윗 정보
    var basicInfo = tweetResponse.basicInfo || {
        id: '',
        createdAt: new Date().toISOString(),
        content: ''
    };
    // 사용자 정보 추출
    var authorInfo = ((_tweetResponse_author = tweetResponse.author) === null || _tweetResponse_author === void 0 ? void 0 : _tweetResponse_author.basicInfo) || {
        id: '',
        username: '',
        displayName: ''
    };
    // 참여 통계
    var engagement = tweetResponse.engagement || {
        likeCount: '0',
        commentCount: '0',
        retweetCount: '0',
        viewCount: '0'
    };
    // 사용자 상호작용
    var userInteraction = tweetResponse.userInteraction || {
        liked: false,
        bookmarked: false
    };
    // 미디어 정보 처리
    var media = tweetResponse.media || {
        mediaUrls: []
    };
    // 인용 또는 리트윗된 트윗 처리
    var referencedTweet = tweetResponse.referencedTweet;
    var isQuote = false;
    var isRetweet = false;
    var quotedTweet;
    var originalTweet;
    if (referencedTweet) {
        if (referencedTweet.type === 'QUOTED') {
            isQuote = true;
            if (referencedTweet.tweet) {
                quotedTweet = tweetDataAdapter(referencedTweet.tweet);
            }
        } else if (referencedTweet.type === 'RETWEETED') {
            isRetweet = true;
            if (referencedTweet.tweet) {
                originalTweet = tweetDataAdapter(referencedTweet.tweet);
            }
        }
    }
    // 변환된 트윗 객체 반환
    return {
        id: basicInfo.id || '',
        content: basicInfo.content || '',
        author: {
            id: authorInfo.id || '',
            name: authorInfo.displayName || '',
            username: authorInfo.username || '',
            profileImage: authorInfo.profileImageUrl || '',
            verified: false // API에 verified 필드가 없으므로 기본값 사용
        },
        createdAt: basicInfo.createdAt || new Date().toISOString(),
        images: media.mediaUrls || [],
        videos: [],
        likesCount: parseInt(engagement.likeCount || '0', 10),
        repliesCount: parseInt(engagement.commentCount || '0', 10),
        retweetsCount: parseInt(engagement.retweetCount || '0', 10),
        viewsCount: parseInt(engagement.viewCount || '0', 10),
        isLiked: userInteraction.liked || false,
        isRetweetedByMe: false,
        isQuote: isQuote,
        quotedTweet: quotedTweet,
        isRetweet: isRetweet,
        originalTweet: originalTweet
    };
};
